export const initialHabitacionForm = () => ({
    nombre: "",
    descripcion: "",
    comentarios: "",
    disponible: true,
});

export const mapHabitacionToForm = (h) => ({
    nombre: h?.nombre || "",
    descripcion: h?.descripcion || "",
    comentarios: h?.comentarios || "",
    disponible: !!h?.disponible,
});
